// Catalogue de codes NAF (INSEE) pour les métiers artisanaux et de service B2B ciblés.
// Utilisé par le preset "Autre" avec recherche libre.
export const NAF_CATALOG = [
  // --- Bâtiment / Construction ---
  { code: "41.20A", label: "Construction de maisons individuelles", cat: "Bâtiment" },
  { code: "41.20B", label: "Construction d'autres bâtiments", cat: "Bâtiment" },
  { code: "43.11Z", label: "Travaux de démolition", cat: "Bâtiment" },
  { code: "43.12A", label: "Terrassement courant / travaux préparatoires", cat: "Bâtiment" },
  { code: "43.21A", label: "Travaux d'installation électrique — bâtiments d'habitation", cat: "Bâtiment" },
  { code: "43.21B", label: "Travaux d'installation électrique — autres bâtiments", cat: "Bâtiment" },
  { code: "43.22A", label: "Plomberie / chauffage sanitaire", cat: "Bâtiment" },
  { code: "43.22B", label: "Climatisation, ventilation", cat: "Bâtiment" },
  { code: "43.29A", label: "Isolation (thermique, phonique)", cat: "Bâtiment" },
  { code: "43.29B", label: "Autres travaux d'installation", cat: "Bâtiment" },
  { code: "43.31Z", label: "Plâtrerie", cat: "Bâtiment" },
  { code: "43.32A", label: "Menuiserie bois / PVC", cat: "Bâtiment" },
  { code: "43.32B", label: "Menuiserie métallique / serrurerie", cat: "Bâtiment" },
  { code: "43.32C", label: "Agencement de lieux de vente", cat: "Bâtiment" },
  { code: "43.33Z", label: "Revêtement des sols et des murs (carrelage)", cat: "Bâtiment" },
  { code: "43.34Z", label: "Peinture et vitrerie", cat: "Bâtiment" },
  { code: "43.39Z", label: "Autres travaux de finition", cat: "Bâtiment" },
  { code: "43.91A", label: "Charpente", cat: "Bâtiment" },
  { code: "43.91B", label: "Couverture, zinguerie", cat: "Bâtiment" },
  { code: "43.99A", label: "Étanchéité", cat: "Bâtiment" },
  { code: "43.99B", label: "Travaux de montage de structures métalliques", cat: "Bâtiment" },
  { code: "43.99C", label: "Maçonnerie générale, gros œuvre", cat: "Bâtiment" },
  { code: "43.99D", label: "Autres travaux spécialisés (échafaudages…)", cat: "Bâtiment" },
  { code: "43.99E", label: "Location d'engins de construction avec opérateur", cat: "Bâtiment" },
  { code: "81.30Z", label: "Paysagistes / entretien espaces verts", cat: "Bâtiment" },

  // --- Ameublement / Cuisines ---
  { code: "31.01Z", label: "Fabrication de meubles de bureau / magasin", cat: "Ameublement" },
  { code: "31.02Z", label: "Fabrication de meubles de cuisine", cat: "Ameublement" },
  { code: "31.03Z", label: "Fabrication de matelas", cat: "Ameublement" },
  { code: "31.09A", label: "Fabrication d'autres meubles / sièges", cat: "Ameublement" },
  { code: "31.09B", label: "Fabrication d'autres meubles (n.c.a.)", cat: "Ameublement" },
  { code: "47.59A", label: "Commerce de détail de meubles", cat: "Ameublement" },
  { code: "47.59B", label: "Commerce de détail équipement du foyer", cat: "Ameublement" },

  // --- Automobile ---
  { code: "45.11Z", label: "Commerce de voitures / véhicules légers", cat: "Automobile" },
  { code: "45.19Z", label: "Commerce d'autres véhicules automobiles", cat: "Automobile" },
  { code: "45.20A", label: "Entretien / réparation de véhicules légers", cat: "Automobile" },
  { code: "45.20B", label: "Entretien / réparation autres véhicules automobiles", cat: "Automobile" },
  { code: "45.31Z", label: "Commerce de gros d'équipements automobiles", cat: "Automobile" },
  { code: "45.32Z", label: "Commerce de détail d'équipements automobiles", cat: "Automobile" },
  { code: "45.40Z", label: "Commerce et réparation de motocycles", cat: "Automobile" },
  { code: "29.20Z", label: "Fabrication de carrosseries", cat: "Automobile" },

  // --- Métaux / mécanique ---
  { code: "25.11Z", label: "Fabrication de structures métalliques", cat: "Métallerie" },
  { code: "25.12Z", label: "Fabrication de portes et fenêtres en métal", cat: "Métallerie" },
  { code: "25.50A", label: "Forge, estampage, matriçage", cat: "Métallerie" },
  { code: "25.61Z", label: "Traitement et revêtement des métaux", cat: "Métallerie" },
  { code: "25.62A", label: "Décolletage", cat: "Métallerie" },
  { code: "25.62B", label: "Mécanique industrielle", cat: "Métallerie" },
  { code: "25.71Z", label: "Fabrication de coutellerie", cat: "Métallerie" },
  { code: "25.72Z", label: "Fabrication de serrures et ferrures", cat: "Métallerie" },
  { code: "25.99A", label: "Fabrication d'articles métalliques ménagers", cat: "Métallerie" },

  // --- Bois ---
  { code: "16.10A", label: "Sciage et rabotage du bois hors panneaux", cat: "Bois" },
  { code: "16.10B", label: "Imprégnation du bois", cat: "Bois" },
  { code: "16.21Z", label: "Fabrication de placage et panneaux de bois", cat: "Bois" },
  { code: "16.22Z", label: "Fabrication de parquets assemblés", cat: "Bois" },
  { code: "16.23Z", label: "Fabrication de charpentes et menuiseries", cat: "Bois" },
  { code: "16.24Z", label: "Fabrication d'emballages en bois", cat: "Bois" },
  { code: "16.29A", label: "Fabrication d'objets divers en bois", cat: "Bois" },

  // --- Boulangerie / Restauration / Alimentaire ---
  { code: "10.71B", label: "Cuisson de produits de boulangerie", cat: "Alimentaire" },
  { code: "10.71C", label: "Boulangerie et boulangerie-pâtisserie", cat: "Alimentaire" },
  { code: "10.71D", label: "Pâtisserie", cat: "Alimentaire" },
  { code: "10.13B", label: "Charcuterie", cat: "Alimentaire" },
  { code: "56.10A", label: "Restauration traditionnelle", cat: "Alimentaire" },
  { code: "56.10B", label: "Cafétérias et libre-service", cat: "Alimentaire" },
  { code: "56.10C", label: "Restauration de type rapide", cat: "Alimentaire" },
  { code: "56.30Z", label: "Débits de boissons", cat: "Alimentaire" },
  { code: "47.24Z", label: "Commerce de détail pain, pâtisserie", cat: "Alimentaire" },
  { code: "47.22Z", label: "Commerce de détail viandes / boucherie", cat: "Alimentaire" },

  // --- Beauté / Services ---
  { code: "96.02A", label: "Coiffure", cat: "Services" },
  { code: "96.02B", label: "Soins de beauté", cat: "Services" },
  { code: "96.03Z", label: "Pompes funèbres", cat: "Services" },
  { code: "96.04Z", label: "Entretien corporel / bien-être", cat: "Services" },
  { code: "96.01A", label: "Blanchisserie-teinturerie de gros", cat: "Services" },
  { code: "96.01B", label: "Blanchisserie-teinturerie de détail", cat: "Services" },
  { code: "95.11Z", label: "Réparation d'ordinateurs / équipements informatiques", cat: "Services" },
  { code: "95.12Z", label: "Réparation d'équipements de communication", cat: "Services" },
  { code: "95.21Z", label: "Réparation de produits électroniques grand public", cat: "Services" },
  { code: "95.22Z", label: "Réparation d'appareils électroménagers, jardin", cat: "Services" },
  { code: "95.23Z", label: "Réparation de chaussures et articles en cuir", cat: "Services" },
  { code: "95.24Z", label: "Réparation de meubles et d'équipements du foyer", cat: "Services" },
  { code: "95.25Z", label: "Réparation d'articles d'horlogerie et de bijouterie", cat: "Services" },

  // --- Fleurs / Jardin ---
  { code: "47.76Z", label: "Commerce détail fleurs, plantes, animaux", cat: "Végétal" },
  { code: "01.30Z", label: "Reproduction des plantes", cat: "Végétal" },
  { code: "01.19Z", label: "Autres cultures non permanentes", cat: "Végétal" },

  // Recrutement & chasse de têtes
  { code: "78.10Z", label: "Agences de placement / recrutement", cat: "Recrutement" },
  { code: "78.30Z", label: "Mise à disposition de ressources humaines", cat: "Recrutement" },
  { code: "78.20Z", label: "Travail temporaire / intérim", cat: "Recrutement" },

  // Formation & enseignement privé
  { code: "85.59A", label: "Formation continue d'adultes", cat: "Formation" },
  { code: "85.59B", label: "Autres enseignements (écoles privées, digital)", cat: "Formation" },
  { code: "85.42Z", label: "Enseignement supérieur (post-bac privé)", cat: "Formation" },
  { code: "85.32Z", label: "Enseignement secondaire technique / pro", cat: "Formation" },
  { code: "85.60Z", label: "Activités de soutien à l'enseignement", cat: "Formation" },

  // ESN, IT & conseil B2B
  { code: "62.02A", label: "Conseil en systèmes et logiciels (ESN, cyber, cloud)", cat: "IT & Conseil" },
  { code: "62.02B", label: "Tierce maintenance de systèmes / applications", cat: "IT & Conseil" },
  { code: "62.01Z", label: "Programmation informatique", cat: "IT & Conseil" },
  { code: "62.03Z", label: "Gestion d'installations informatiques (infogérance, MSP)", cat: "IT & Conseil" },
  { code: "62.09Z", label: "Autres activités informatiques", cat: "IT & Conseil" },
  { code: "63.11Z", label: "Traitement de données, hébergement, cloud", cat: "IT & Conseil" },
  { code: "58.29A", label: "Édition de logiciels système et de réseau", cat: "IT & Conseil" },
  { code: "58.29C", label: "Édition de logiciels applicatifs (ERP, SaaS)", cat: "IT & Conseil" },
  { code: "70.22Z", label: "Conseil pour les affaires et la gestion", cat: "IT & Conseil" },

  // Services B2B lourds
  { code: "64.99Z", label: "Autres services financiers (affacturage)", cat: "Services B2B" },
  { code: "64.92Z", label: "Autre distribution de crédit", cat: "Services B2B" },
  { code: "66.19B", label: "Autres activités auxiliaires de services financiers", cat: "Services B2B" },
  { code: "66.22Z", label: "Agents et courtiers d'assurances", cat: "Services B2B" },
  { code: "66.21Z", label: "Évaluation des risques et dommages", cat: "Services B2B" },
  { code: "52.29A", label: "Messagerie, fret express", cat: "Services B2B" },
  { code: "52.29B", label: "Affrètement et organisation des transports", cat: "Services B2B" },
  { code: "52.10B", label: "Entreposage et stockage non frigorifique", cat: "Services B2B" },
  { code: "52.10A", label: "Entreposage et stockage frigorifique", cat: "Services B2B" },
  { code: "49.41A", label: "Transports routiers de fret interurbains", cat: "Services B2B" },
  { code: "49.41B", label: "Transports routiers de fret de proximité", cat: "Services B2B" },
  { code: "82.99Z", label: "Autres services de soutien aux entreprises", cat: "Services B2B" },
  { code: "82.11Z", label: "Services administratifs combinés de bureau", cat: "Services B2B" },
  { code: "69.20Z", label: "Comptabilité, audit, conseil fiscal", cat: "Services B2B" },
  { code: "73.11Z", label: "Agences de publicité / marketing B2B", cat: "Services B2B" },
];

export const NAF_CATEGORIES = [
  "Bâtiment", "Ameublement", "Automobile", "Métallerie",
  "Bois", "Alimentaire", "Services", "Végétal",
  "Recrutement", "Formation", "IT & Conseil", "Services B2B",
];
